var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebdiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAtFBMVEUAAACAgICAgICAgICA gICAgICAgICAgICAgICAgICAgICAgICAgICZmZmSkpKAgYGAgoKAgoKAgYGAgoKAgoKAgICAgoKA gYGAgYGAgoKAgoKAgoKAgoKAgoKAgoKAgoKAgoKAgICAgYGQkJCwsLDHx8ff39/X2NiAgoLf4OD/ ///39/fPz8+goKDHyMjX19eYmJiIiIioqanAwMCIiYm4uLiYmZmgoaHAwcHP0NCQkpLv7++9OCea AAAAIXRSTlMAIEAwEGCv73CAz7/f79+AgHCfn7+f73CP368wII/PEEAuBkbSAAAAAWJLR0QqU77U ngAAAAd0SU1FB+UCEw8IGozWv88AAAD7SURBVDjL7ZLbcoIwEEATBUKILSjUFm2rEUsjMUqhpbf/ /68m64w3sPatPnAedjKbM8nuJgi1tPwF3AEw6v4iWbZDOJ9xgLj4lEZJMn9Kn8Uiy2S6nCfcs61G TaWZZmVEYJ1zQo8qwC7hL0vYLrZimm+KcEDp2pT1NomkLEulXme5Unwfpi3n6jDXCEPWtczK82IP uepN1+sHfZ/Ut8kgjAIPlujGRF9U1fC2Lt6J6l2EUD5yTEvxh+505NXuGxVmVBREE6mZxmfEah1E +oAFiB7q6HNYXEhZhTY9wg2+vmUR4d3Ax0Mh4vuGJ30Q4nG8n5hMp//9ZVsuhh+awzGwIm988gAA ACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0wMi0xOVQxNTowODoyNiswMDowMIff4YgAAAAldEVYdGRh dGU6bW9kaWZ5ADIwMjEtMDItMTlUMTU6MDg6MjYrMDA6MDD2glk0AAAAGXRFWHRTb2Z0d2FyZQBB ZG9iZSBJbWFnZVJlYWR5ccllPAAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdiscountIcon);
export default __webpack_public_path__ + "static/media/webdiscount-icon.95714e9a90059d87853c993da4966745.svg";
export { ForwardRef as ReactComponent };